module.exports = __webpack_public_path__ + "static/media/Desk_Calendar_Mockup_OK_3.21cb4b91.jpg";